import { render, staticRenderFns } from "./deliveryorderCoupons.vue?vue&type=template&id=0f0f1cd7&scoped=true&"
import script from "./deliveryorderCoupons.vue?vue&type=script&lang=js&"
export * from "./deliveryorderCoupons.vue?vue&type=script&lang=js&"
import style0 from "./deliveryorderCoupons.vue?vue&type=style&index=0&id=0f0f1cd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f1cd7",
  null
  
)

export default component.exports